var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image_captions"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.text !== 'undefined'),expression:"text !== 'undefined'"}]},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }